<main>
	<div class="container">
		<div class="content-container">
            <slot/>
		</div>
	</div>
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		margin: 0;
		width: 100%;
		min-height: calc(92vh - 48px);
	}

	.container {
		justify-content: center;
		align-items: center;
		text-align: center;
		flex: 1;
		display: flex;
		padding: 24px;
	}

	.content-container {
		text-align: left;
		width: 100%;
		max-width: 640px;
	}
</style>